/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowCircleDownLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm33.65625,81.65625L119.3125,148H148a8,8,0,0,1,0,16H100a8.02752,8.02752,0,0,1-8-8V108a8,8,0,0,1,16,0v28.6875l42.34375-42.34375a7.99915,7.99915,0,0,1,11.3125,11.3125Z" />
    </Svg>
  );
}

export default ArrowCircleDownLeft;
